module.exports = __webpack_public_path__ + "static/media/foto2.17af39d5.png";